import React, { useEffect, useState } from 'react'
import Preview from './Preview'
import times from 'lodash/times';
import {
  Box,
  Grid,
  RadioGroup,
  Radio,
  FormControlLabel, MenuItem, Checkbox, Button, Input, FormControl,
  ButtonGroup,
  TextField,
  Typography
} from '@material-ui/core'
import clsx from 'clsx';
import { first, get, range } from 'lodash';
import { PulButton, PulColItem, PulDivider, PulHead, PulImage, PulPara, PulRow } from '../../screens/HtmlCampaign/helper/Template';
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from "react-i18next";
import { ProductCatalogTypes } from './Types';
import { AddProductCatalogType, Direction, EventTypes, Items, ProductDetails, Structure } from '../../config/enum';
import { useDispatch, useSelector } from 'react-redux';
import { StateType } from '../../Models/StateTypes';
import Select from '@mui/material/Select';
import { IoIosArrowDown } from 'react-icons/io';
import { DynamicProductGrid, NO_IMAGE_URL } from '../../helpers/Constants';
import { BaseDialog } from '../../components/DialogTemplates/BaseDialog';
import { GetProductsList } from '../../redux/reducers/productSlice';
import { ProductDetailsInterface, StaticProductListInterface } from '../../Models/Newsletter/ProductCatalog';
import { Autocomplete } from '@mui/material';
import Toast from '../../components/Toast/Toast.component';

const StaticProductInit: ProductDetailsInterface = {
  CategoriesId: '',
  CategoriesName: '',
  Description: '',
  ID: 0,
  ImageURLs: NO_IMAGE_URL,
  MaxPrice: ProductDetails.Price,
  Name: ProductDetails.Name,
  URL: '',
  Error: '',
};

const ProductCatalog = ({ classes, isOpen = true, save }: ProductCatalogTypes) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { productList } = useSelector((state: StateType) => state.product)
  const [isSingleOrMultiple, setSingleOrMultiple] = useState(Items.Single);
  const [selectedStaticProduct, setSelectedStaticProduct] = useState<number>(1);
  const [staticProduct, setStaticProduct] = useState<StaticProductListInterface>({ 1: StaticProductInit });
  const [uptoProducts, setUptoProducts] = useState(1);
  const [isFilterByEventType, setFilterIsByEventType] = useState(true);
  const [isFilterIsByProductCategory, setFilterIsByProductCategory] = useState(true);
  const [isImageVisible, setImageVisibility] = useState(true);
  const [isNameVisible, setNameVisibility] = useState(true);
  const [isDescriptionVisible, setDescriptionVisibility] = useState(false);
  const [isPriceVisible, setPriceVisibility] = useState(true);
  const [isButtonVisible, setButtonVisibility] = useState(true);
  const [buttonText, setButtonText] = useState('');
  const [structure, setStructure] = useState(Structure.Vertical);
  const [eventType, setEventType] = useState(EventTypes.Purchase);
  const [category, setCategory] = useState(0);
  const [maxProducts, setMaxProducts] = useState(2);
  const [productOrder, setProductOrder] = useState(Structure.Vertical);
  const { isRTL } = useSelector((state: StateType) => state.core);
  const { productCategories } = useSelector((state: StateType) => state.product);
  const [direction, setDirection] = useState(isRTL ? Direction.RightToLeft : Direction.LeftToRight);
  const [isStaticOrDynamic, setIsStaticOrDynamic] = useState(AddProductCatalogType.Dynamic);
  const [toastMessage, setToastMessage] = useState(null);

  useEffect(() => {
    if (structure === Structure.Horizontal) {
      setProductOrder(Structure.Horizontal);
      setMaxProducts(2);
      setUptoProducts(isSingleOrMultiple === Items.Multiple ? 2 : 1);
    }

    if (productOrder === Structure.Vertical && structure === Structure.Vertical && isSingleOrMultiple === Items.Multiple) {
      setMaxProducts(4);
      setDirection(Direction.Center);
    } else {
      setDirection(isRTL ? Direction.RightToLeft : Direction.LeftToRight);
    }

    if (structure === Structure.Vertical && productOrder === Structure.Horizontal && isSingleOrMultiple === Items.Multiple) {
      setMaxProducts(4);
      if (uptoProducts === 3) {
        setNameVisibility(true);
      } else if (uptoProducts === 4) {
        setNameVisibility(false);
      } else {
        setNameVisibility(true);
      }
    }
  }, [productOrder, structure]);

  useEffect(() => {
    if (isSingleOrMultiple === Items.Multiple) {
      setStructure(Structure.Vertical);
      setProductOrder(Structure.Vertical);
      setUptoProducts(2);
    } else {
      setUptoProducts(1);
    }

    if (productOrder === Structure.Vertical && structure === Structure.Vertical && isSingleOrMultiple === Items.Multiple) {
      setDirection(Direction.Center);
    } else {
      setDirection(isRTL ? Direction.RightToLeft : Direction.LeftToRight);
    }
    if (structure === Structure.Vertical && productOrder === Structure.Vertical && isSingleOrMultiple === Items.Multiple) {
      setMaxProducts(4);
    } else {
      setMaxProducts(2);
    }
  }, [isSingleOrMultiple]);

  useEffect(() => {
    if (structure === Structure.Vertical && productOrder === Structure.Horizontal && isSingleOrMultiple === Items.Multiple && uptoProducts > 2) {
      if (uptoProducts === 3) {
        setNameVisibility(true);
      } else if (uptoProducts === 4) {
        setNameVisibility(false);
      }
    } else {
      setNameVisibility(true);
    }

    if (isStaticOrDynamic === AddProductCatalogType.Static) {
      let staticProductList: StaticProductListInterface = {};
      for (let ind = 1; ind <= uptoProducts; ind++) {
        staticProductList[ind] = StaticProductInit;
      }
      setStaticProduct(staticProductList);
      setSelectedStaticProduct(1);
    }
  }, [uptoProducts]);

  useEffect(() => {
    if (isStaticOrDynamic === AddProductCatalogType.Static) {
      setSingleOrMultiple(Items.Single);
    }
  }, [isStaticOrDynamic])

  useEffect(() => {
    setButtonText(t('campaigns.buyNow'));
  }, []);

  const onHandleSave = async () => {
    if (isStaticOrDynamic === AddProductCatalogType.Static) {
      let isFormComplete = true;
      for (var key in staticProduct) {
        if (staticProduct[key]['ID'] === 0) {
          isFormComplete = false;
          staticProduct[key]['Error'] = t('campaigns.selectProduct');
        } else {
          staticProduct[key]['Error'] = '';
        }
      }
      if (!isFormComplete) {
        // @ts-ignore
        setToastMessage({ severity: 'error', color: 'error', message: "campaigns.selectAllStaticProducts", showAnimtionCheck: false });
        return false;
      }
    }

    let dynamicRow = JSON.parse(JSON.stringify(PulRow));
    // dynamicRow['container']['style']['direction'] = direction;
    if (isStaticOrDynamic === AddProductCatalogType.Dynamic) dynamicRow['container']['style']['product-block-container'] = '1';
    if (structure === Structure.Horizontal) dynamicRow['content']['style']['direction'] = direction;
    dynamicRow['metadata']["StaticOrDynamic"] = isStaticOrDynamic;
    dynamicRow['metadata']["EventType"] = eventType.toString(); //getEventName(eventType);
    dynamicRow['metadata']["ProductCategory"] = category;
    dynamicRow['metadata']["EventTypeEnabled"] = isFilterByEventType;
    dynamicRow['metadata']["ProductCategoryEnabled"] = isFilterIsByProductCategory;
    dynamicRow['metadata']["NumOfProdcuts"] = uptoProducts;
    // dynamicRow['metadata']["direction"] = direction.toUpperCase();
    dynamicRow['metadata']["order"] = productOrder;
    dynamicRow['metadata']["category"] = category ? productCategories.find((cat: any) => cat.CategoryId == category)?.CategoryName : t('campaigns.allCategories');

    const alignment = direction === Direction.Center ? 'center' : (direction == Direction.RightToLeft ? 'right' : 'left');
    if (structure === Structure.Horizontal && productOrder === Structure.Vertical && isSingleOrMultiple === Items.Multiple) {
      var productJSON: any = await getProductJSON(alignment);
      productJSON[0]['grid-columns'] = 4;
      productJSON[1]['grid-columns'] = 8;
      for (let ind = 1; ind < uptoProducts; ind++) {
        var productJSONStatic: any = await getProductJSON(alignment, ind + 1);
        const mod0 = productJSONStatic[0]['modules'];
        const mod1 = productJSONStatic[1]['modules'];
        productJSON[0]['modules'] = productJSON[0]['modules'].concat(mod0);
        productJSON[1]['modules'] = productJSON[1]['modules'].concat(mod1);
      }
      dynamicRow['columns'].push(productJSON[0]);
      dynamicRow['columns'].push(productJSON[1]);
    } else {
      if (uptoProducts > 0) {
        if (productOrder === Structure.Horizontal) {
          for (let ind = 0; ind < uptoProducts; ind++) {
            var productJSON: any = await getProductJSON(alignment, ind + 1);
            dynamicRow['columns'] = dynamicRow['columns'].concat(productJSON);
          }
        } else if (productOrder === Structure.Vertical) {
          var modules: any = [];
          for (let ind = 0; ind < uptoProducts; ind++) {
            var productJSON: any = await getProductJSON(alignment, ind + 1);
            for (let indJ = 0; indJ < productJSON.length; indJ++) {
              modules = modules.concat(productJSON[indJ]['modules']);
            }
            if (ind < uptoProducts - 1) modules = modules.concat(PulDivider);
          }

          if (structure === Structure.Vertical) {
            var productJSON: any = await getProductJSON(alignment);
            productJSON[0]['modules'] = modules;
            dynamicRow['columns'] = dynamicRow['columns'].concat(productJSON);
          } else {
            for (let ind = 0; ind < uptoProducts; ind++) {
              var productJSON: any = await getProductJSON(alignment, ind + 1);
              dynamicRow['columns'] = dynamicRow['columns'].concat(productJSON);
              dynamicRow['columns'] = dynamicRow['columns'].concat(PulDivider as any);
            }
          }
        }
      } else {
        var productJSON: any = await getProductJSON(alignment);
        dynamicRow['columns'] = dynamicRow['columns'].concat(productJSON);
      }
    }

    setTimeout(() => {
      save({
        success: true,
        row: dynamicRow,
      })
    }, 1);
  };

  const getProductJSON = async (alignment: string, staticProductIndex: number = 1) => {
    const productJSON = [];
    if (structure === Structure.Horizontal) {
      const imageCol = DynamicProductGrid[`Item_${uptoProducts}`].image;
      const contentCol = DynamicProductGrid[`Item_${uptoProducts}`].content;
      var productCol: any = JSON.parse(JSON.stringify(PulColItem));
      productCol['uuid'] = uuidv4();
      if (isImageVisible) {
        let image = JSON.parse(JSON.stringify(PulImage));
        image['uuid'] = uuidv4();
        image['descriptor']['image']['src'] = isStaticOrDynamic === AddProductCatalogType.Dynamic ? NO_IMAGE_URL : staticProduct[staticProductIndex].ImageURLs;
        image['descriptor']['image']['style']['text-align'] = alignment;
        image['descriptor']['style']['width'] = '100%';
        image['descriptor']['style']['text-align'] = alignment;
        if (structure === Structure.Horizontal && productOrder === Structure.Vertical && isSingleOrMultiple == Items.Multiple) {
          image['descriptor']['style']['padding-bottom'] = '25px';
        }
        image['descriptor']['computedStyle']['class'] = 'fullwidthOnMobile';
        image['descriptor']['computedStyle']['width'] = 300;
        image['align'] = alignment;
        productCol['modules'].push(image);
        productCol['grid-columns'] = imageCol;
        productJSON.push(productCol);
      }

      var productCol: any = JSON.parse(JSON.stringify(PulColItem));
      productCol['uuid'] = uuidv4();
      const moduleItems = [];
      if (isNameVisible) {
        let head = JSON.parse(JSON.stringify(PulHead));
        head['uuid'] = uuidv4();
        head['descriptor']['heading']['text'] = isStaticOrDynamic === AddProductCatalogType.Dynamic ? '#name#' : staticProduct[staticProductIndex].Name;
        head['descriptor']['heading']['style']['text-align'] = alignment;
        moduleItems.push(head);
      }

      if (isDescriptionVisible) {
        let desc = JSON.parse(JSON.stringify(PulPara));
        desc['uuid'] = uuidv4();
        desc['descriptor']['paragraph']['html'] = isStaticOrDynamic === AddProductCatalogType.Dynamic ? '#description#' : staticProduct[1].Description;
        desc['descriptor']['paragraph']['style']['text-align'] = alignment;
        moduleItems.push(desc);
      }

      if (isPriceVisible) {
        let price = JSON.parse(JSON.stringify(PulPara));
        price['uuid'] = uuidv4();
        price['descriptor']['paragraph']['html'] = isStaticOrDynamic === AddProductCatalogType.Dynamic ? '#price#' : staticProduct[staticProductIndex].MaxPrice;
        price['descriptor']['paragraph']['style']['text-align'] = alignment;
        moduleItems.push(price);
      }

      if (isStaticOrDynamic === AddProductCatalogType.Dynamic && isFilterByEventType) {
        let event = JSON.parse(JSON.stringify(PulPara));
        event['uuid'] = uuidv4();
        event['descriptor']['paragraph']['style']['pulseem-hide'] = '1';
        event['descriptor']['paragraph']['html'] = getEventName(eventType);
        event['descriptor']['paragraph']['style']['text-align'] = alignment;
        event['descriptor']['computedStyle']['hideContentOnHtml'] = true;
        moduleItems.push(event);
      }

      if (isStaticOrDynamic === AddProductCatalogType.Dynamic && isFilterIsByProductCategory) {
        let cat = JSON.parse(JSON.stringify(PulPara));
        cat['uuid'] = uuidv4();
        cat['descriptor']['paragraph']['style']['pulseem-hide'] = '1';
        cat['descriptor']['paragraph']['html'] = isStaticOrDynamic === AddProductCatalogType.Dynamic ? (category ? productCategories.find((cat: any) => cat.CategoryId == category)?.CategoryName : t('campaigns.allCategories')) : staticProduct[staticProductIndex].CategoriesName;
        cat['descriptor']['paragraph']['style']['text-align'] = alignment;
        cat['descriptor']['computedStyle']['hideContentOnHtml'] = true;
        moduleItems.push(cat);
      }

      if (isButtonVisible && buttonText) {
        let button = JSON.parse(JSON.stringify(PulButton));
        button['uuid'] = uuidv4();
        button['descriptor']['button']['label'] = buttonText;
        button['descriptor']['style']['text-align'] = alignment;
        if (isStaticOrDynamic === AddProductCatalogType.Static) button['descriptor']['button']['href'] = staticProduct[staticProductIndex].URL;
        moduleItems.push(button);
      }

      if (isImageVisible) productCol['grid-columns'] = contentCol;
      productCol['modules'] = moduleItems;
      productJSON.push(productCol);
    } else {
      let productCol: any = JSON.parse(JSON.stringify(PulColItem));
      productCol['uuid'] = uuidv4();
      productCol['grid-columns'] = 12 / (productOrder === Structure.Vertical ? 1 : uptoProducts);
      let moduleItems = [];
      if (isImageVisible) {
        let image = JSON.parse(JSON.stringify(PulImage));
        image['uuid'] = uuidv4();
        image['descriptor']['image']['src'] = isStaticOrDynamic === AddProductCatalogType.Dynamic ? NO_IMAGE_URL : staticProduct[staticProductIndex].ImageURLs;
        image['descriptor']['image']['style']['text-align'] = alignment;
        image['descriptor']['image']['percWidth'] = productOrder === Structure.Vertical || isSingleOrMultiple === Items.Single ? '30' : '100';
        image['descriptor']['style']['text-align'] = alignment;
        image['descriptor']['style']['padding-left'] = '20px';
        image['descriptor']['style']['padding-right'] = '20px';
        // if (alignment !== Direction.Center) image['descriptor']['style']['display'] = 'flex';
        image['descriptor']['computedStyle']['class'] = `${alignment} fixedwidth fullwidthOnMobile`;
        image['descriptor']['computedStyle']['style'] = `text-align: ${alignment}`;

        image['descriptor']['style']['width'] = '100%';
        image['descriptor']['computedStyle']['width'] = 300;
        image['align'] = alignment;
        moduleItems.push(image);
      }

      if (isNameVisible) {
        let head = JSON.parse(JSON.stringify(PulHead));
        head['uuid'] = uuidv4();
        head['descriptor']['heading']['text'] = isStaticOrDynamic === AddProductCatalogType.Dynamic ? '#name#' : staticProduct[staticProductIndex].Name;
        head['descriptor']['heading']['style']['text-align'] = alignment;
        moduleItems.push(head);
      }

      if (isDescriptionVisible) {
        let desc = JSON.parse(JSON.stringify(PulPara));
        desc['uuid'] = uuidv4();
        desc['descriptor']['paragraph']['html'] = isStaticOrDynamic === AddProductCatalogType.Dynamic ? '#description#' : staticProduct[staticProductIndex].Description;
        desc['descriptor']['paragraph']['style']['text-align'] = alignment;
        moduleItems.push(desc);
      }

      if (isPriceVisible) {
        let price = JSON.parse(JSON.stringify(PulPara));
        price['uuid'] = uuidv4();
        price['descriptor']['paragraph']['html'] = isStaticOrDynamic === AddProductCatalogType.Dynamic ? '#price#' : staticProduct[staticProductIndex].MaxPrice;
        price['descriptor']['paragraph']['style']['text-align'] = alignment;
        moduleItems.push(price);
      }

      if (isStaticOrDynamic === AddProductCatalogType.Dynamic && isFilterByEventType) {
        let event = JSON.parse(JSON.stringify(PulPara));
        event['uuid'] = uuidv4();
        event['descriptor']['paragraph']['html'] = getEventName(eventType);
        event['descriptor']['paragraph']['style']['text-align'] = alignment;
        event['descriptor']['paragraph']['style']['pulseem-hide'] = '1';
        event['descriptor']['computedStyle']['hideContentOnHtml'] = true;
        moduleItems.push(event);
      }

      if (isStaticOrDynamic === AddProductCatalogType.Dynamic && isFilterIsByProductCategory) {
        let cat = JSON.parse(JSON.stringify(PulPara));
        cat['uuid'] = uuidv4();
        cat['descriptor']['paragraph']['html'] = isStaticOrDynamic === AddProductCatalogType.Dynamic ? (category ? productCategories.find((cat: any) => cat.CategoryId == category)?.CategoryName : t('campaigns.allCategories')) : staticProduct[staticProductIndex].CategoriesName;
        cat['descriptor']['paragraph']['style']['text-align'] = alignment;
        cat['descriptor']['paragraph']['style']['pulseem-hide'] = '1';
        cat['descriptor']['computedStyle']['hideContentOnHtml'] = true;
        moduleItems.push(cat);
      }

      if (isButtonVisible && buttonText) {
        let button = JSON.parse(JSON.stringify(PulButton));
        button['uuid'] = uuidv4();
        button['descriptor']['button']['label'] = buttonText || t('campaigns.buttonText');
        button['descriptor']['style']['text-align'] = alignment;
        if (isStaticOrDynamic === AddProductCatalogType.Static) button['descriptor']['button']['href'] = staticProduct[staticProductIndex].URL;
        moduleItems.push(button);
      }
      productCol['modules'] = moduleItems;
      productJSON.push(productCol);
    }
    return productJSON;
  }

  const onHandleCancel = React.useCallback(() => {
    save({
      success: true,
      row: '',
    })
  }, []);

  const getProductNumbers = () => {
    return range(2, maxProducts + 1).map((item: number) => <MenuItem key={`${item}`} value={`${item}`}>{item}</MenuItem>)
  }

  const getProductButtons = () => {
    return range(1, uptoProducts + 1).map((item: number) => <Button className={clsx(classes.btn, classes.w50, selectedStaticProduct === item ? classes.redButton : null)} onClick={() => setSelectedStaticProduct(item)}>{item}</Button>)
  }

  const previewContainerHeight = window.innerHeight - 350;

  const getEventName = (eventType: number) => {
    let event = t('campaigns.allEvents');
    switch (eventType) {
      case 1:
        event = t('campaigns.purchase');
        break;

      case 2:
        event = t('campaigns.cartAbandonment');
        break;

      case 3:
        event = t('campaigns.lastViewedProduct');
        break;
    }
    return event;
  }

  const fillProduct = (prodDetails: ProductDetailsInterface = StaticProductInit) => {
    setStaticProduct({
      ...staticProduct,
      [selectedStaticProduct]: {
        ...prodDetails,
        ImageURLs: first(prodDetails.ImageURLs.split(',')) || NO_IMAGE_URL,
        MaxPrice: `${prodDetails.MaxPrice} ${t('common.NIS')}`
      }
    });
  }

  const renderToast = () => {
    if (toastMessage) {
      setTimeout(() => {
        setToastMessage(null);
      }, 3000);
      return (
        <Toast data={toastMessage} />
      );
    }
    return null;
  }

  return (
    <BaseDialog
      open={isOpen}
      classes={classes}
      disableBackdropClick={true}
      title={t(isStaticOrDynamic === AddProductCatalogType.Dynamic ? "campaigns.setupStaticProduct" : "campaigns.setupStaticProduct")}
      showDefaultButtons={false}
      contentStyle={classes.noPadding}
      customContainerStyle={classes.callToAction}
      onCancel={onHandleCancel}
      onClose={onHandleCancel}
      renderButtons={() => (
        <div className={clsx(classes.textCenter, classes.mt25)}>
          <Button
            onClick={onHandleSave}
            variant='contained'
            size='medium'
            className={clsx(
              classes.btn,
              classes.btnRounded
            )}
            color="primary"
          >
            {t('campaigns.addProductBlock')}
          </Button>
          <Button
            onClick={onHandleCancel}
            variant='contained'
            size='medium'
            className={clsx(classes.btn, classes.btnRounded, classes.ml10)}
          >
            {t('common.cancel')}
          </Button>
        </div>
      )}
    >
      <div className='product-block' style={{ direction: isRTL ? 'rtl' : 'ltr' }}>
        <Box>
          <Grid container spacing={5}>
            <Grid item md={5}>
              <ButtonGroup variant="outlined" className={clsx(classes.mb20, classes.w100)}>
                <Button className={clsx(classes.btn, classes.w50, isStaticOrDynamic === AddProductCatalogType.Dynamic ? classes.redButton : null)} onClick={() => setIsStaticOrDynamic(AddProductCatalogType.Dynamic)}>{t('campaigns.createProductBlock')}</Button>
                <Button className={clsx(classes.btn, classes.w50, isStaticOrDynamic === AddProductCatalogType.Static ? classes.redButton : null)} onClick={() => setIsStaticOrDynamic(AddProductCatalogType.Static)}>{t('campaigns.selectProduct')}</Button>
              </ButtonGroup>

              <RadioGroup row aria-label="WebViewLocation" name="WebViewLocation" defaultValue="1" className={clsx(classes.mb10)}>
                <FormControlLabel
                  value={Items.Single}
                  control={<Radio
                    color="primary"
                    checked={isSingleOrMultiple === Items.Single}
                    onChange={(event: any) => {
                      setSingleOrMultiple(event.target.value);
                      setUptoProducts(1);
                    }}
                    value={Items.Single}
                  />
                  }
                  label={t('campaigns.singleProduct')}
                />
                <FormControlLabel
                  value={Items.Multiple}
                  // className={clsx(classes.fullSize)}
                  control={
                    <Radio
                      color="primary"
                      checked={isSingleOrMultiple === Items.Multiple}
                      onChange={(event: any) => setSingleOrMultiple(event.target.value)}
                      value={Items.Multiple}
                    />
                  }
                  label={t("campaigns.multipleProduct")}
                />
              </RadioGroup>
              {
                isSingleOrMultiple === Items.Multiple && (
                  <div className={clsx(classes.pl30, classes.pt5)}>
                    <label className={clsx(classes.pe15)}>{t('campaigns.upto')}</label>
                    <FormControl
                      variant="standard"
                      className={clsx(classes.selectInputFormControl)}
                      style={{ verticalAlign: 'baseline' }}
                    >
                      <Select
                        variant="standard"
                        value={uptoProducts}
                        onChange={(event: any) => setUptoProducts(Number(event.target.value))}
                        IconComponent={() => <IoIosArrowDown size={20} className={classes.dropdownIconComponent} />}
                        style={{ width: '100%' }}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 300,
                              direction: isRTL ? 'rtl' : 'ltr'
                            },
                          },
                        }}
                      >
                        {getProductNumbers()}
                      </Select>
                    </FormControl>
                    <label className={clsx(classes.pl10)}>{t('campaigns.products')}</label>
                  </div>
                )
              }

              {
                isStaticOrDynamic === AddProductCatalogType.Static && isSingleOrMultiple === Items.Multiple && (
                  <>
                    <h4 className={clsx(classes.bold, classes.pt5, classes.mb10)}>{t('campaigns.products')}</h4>
                    <ButtonGroup variant="outlined" className={clsx(classes.mb20, classes.w100)}>
                      {
                        getProductButtons()
                      }
                    </ButtonGroup>
                  </>
                )
              }

              {
                isStaticOrDynamic === AddProductCatalogType.Static && (
                  <div className={clsx(classes.pt5)}>
                    <h4 className={clsx(classes.bold, classes.noMargin, classes.pb10)}>{t('campaigns.selectProduct')}:</h4>
                    <FormControl
                      variant="standard"
                      className={clsx(classes.selectInputFormControl, classes.w100)}
                      style={{ verticalAlign: 'baseline' }}
                    >
                      <Autocomplete
                        // @ts-ignore
                        value={get(staticProduct, [selectedStaticProduct, 'ID'], StaticProductInit.ID) != 0 ? staticProduct[selectedStaticProduct] : null}
                        disablePortal
                        id='pinkScrollbar'
                        className={classes.autoComplete}
                        options={productList}
                        noOptionsText={t("group.noGroupFound")}
                        getOptionLabel={(option: ProductDetailsInterface) => option.Name}
                        getOptionKey={(option: ProductDetailsInterface) => option.ID}
                        renderOption={
                          (props, options: ProductDetailsInterface) => <MenuItem component='li' {...props} key={options.ID} value={options.ID}>{options.Name} ({options.ID})</MenuItem>
                        }
                        style={{ direction: isRTL ? 'rtl' : 'ltr' }}
                        renderInput={(params) => {
                          //@ts-ignore
                          return (<TextField
                            {...params}
                            color="primary" className={clsx(classes.textField, classes.w100)}
                          />)
                        }}
                        disableClearable
                        // isOptionEqualToValue
                        onChange={(event: any, value: any) => fillProduct(value)}
                        popupIcon={<IoIosArrowDown size={20} className={classes.colrPrimary} />}
                      />

                    </FormControl>
                    <Box className='textBoxWrapper'>
                      <Typography className={clsx(get(staticProduct, [selectedStaticProduct, 'Error'], '') ? classes.errorText : 'MuiFormHelperText-root', classes.f14, classes.pt5)}>
                        {get(staticProduct, [selectedStaticProduct, 'Error'], '')}
                      </Typography>
                    </Box>
                  </div>
                )
              }

              {
                isStaticOrDynamic === AddProductCatalogType.Dynamic && (
                  <>
                    <h4 className={clsx(classes.bold, classes.pt5, classes.mb10)}>{t('campaigns.filter')}:</h4>
                    <div className={clsx(classes.mb25)}>
                      <div className={clsx(classes.pb10)}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              defaultChecked={isFilterByEventType}
                              checked={isFilterByEventType}
                              onChange={(event) => setFilterIsByEventType(event.target.checked)}
                              name="by_event_type"
                              color="primary"
                            />
                          }
                          label={t('campaigns.byEventType')}
                        />
                        <FormControl
                          variant="standard"
                          className={clsx(classes.dBlock, classes.selectInputFormControl, classes.ml25)}
                        >
                          <Select
                            variant="standard"
                            displayEmpty
                            IconComponent={() => <IoIosArrowDown size={20} className={classes.dropdownIconComponent} />}
                            value={eventType}
                            onChange={(event: any) => setEventType(event.target.value)}
                            style={{ width: '100%' }}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 300,
                                  direction: isRTL ? 'rtl' : 'ltr'
                                },
                              },
                            }}
                          >
                            <MenuItem value={EventTypes.All}>{t('campaigns.allEvents')}</MenuItem>
                            <MenuItem value={EventTypes.Purchase}>{t('campaigns.purchase')}</MenuItem>
                            <MenuItem value={EventTypes.CartAbandon}>{t('campaigns.cartAbandonment')}</MenuItem>
                            <MenuItem value={EventTypes.LastViewedProduct}>{t('campaigns.lastViewedProduct')}</MenuItem>
                          </Select>
                        </FormControl>
                      </div>

                      <div className='product-type'>
                        <FormControlLabel
                          control={
                            <Checkbox
                              defaultChecked={isFilterIsByProductCategory}
                              checked={isFilterIsByProductCategory}
                              onChange={(event) => setFilterIsByProductCategory(event.target.checked)}
                              name="by_product_category"
                              color="primary"
                            />
                          }
                          label={t('campaigns.byProductCategory')}
                        />
                        <FormControl
                          variant="standard"
                          className={clsx(classes.dBlock, classes.selectInputFormControl, classes.ml25)}
                        >
                          <Select
                            variant="standard"
                            id='category'
                            IconComponent={() => <IoIosArrowDown size={20} className={classes.dropdownIconComponent} />}
                            value={category}
                            onChange={(event: any) => setCategory(event.target.value)}
                            style={{ width: '100%' }}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 300,
                                  direction: isRTL ? 'rtl' : 'ltr'
                                },
                              },
                            }}
                          >
                            <MenuItem key='0' value={0}>{t('campaigns.allCategories')}</MenuItem>
                            {
                              productCategories?.map((item: any) => <MenuItem key={item.CategoryId} value={item.CategoryId}>{item.CategoryName}</MenuItem>)
                            }
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                  </>
                )
              }

              <h4 className={clsx(classes.bold, classes.pt5, classes.mb10)}>{t('campaigns.display')}:</h4>
              <div className={clsx(classes.mb10)}>
                <div className={clsx(classes.dInlineBlock, classes.pb10)}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={isImageVisible}
                        checked={isImageVisible}
                        onChange={(event) => setImageVisibility(event.target.checked)}
                        name="display"
                        color="primary"
                      />
                    }
                    label={t('campaigns.image')}
                  />
                </div>

                <div className={clsx(classes.dInlineBlock, classes.pb10)}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={isNameVisible}
                        checked={isNameVisible}
                        onChange={(event) => setNameVisibility(event.target.checked)}
                        name="display"
                        color="primary"
                        value="Name"
                      />
                    }
                    disabled={structure === Structure.Vertical && productOrder === Structure.Horizontal && isSingleOrMultiple === Items.Multiple && uptoProducts === 4}
                    label={t('campaigns.name')}
                  />
                </div>

                <div className={clsx(classes.dInlineBlock, classes.pb10)}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={isDescriptionVisible}
                        checked={isDescriptionVisible}
                        onChange={(event) => setDescriptionVisibility(event.target.checked)}
                        name="display"
                        color="primary"
                        value="Description"
                        disabled={structure === Structure.Vertical && productOrder === Structure.Horizontal && isSingleOrMultiple === Items.Multiple && (uptoProducts === 3 || uptoProducts === 4)}
                      />
                    }
                    label={t('campaigns.description')}
                  />
                </div>

                <div className={clsx(classes.dInlineBlock, classes.pb10)}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={isPriceVisible}
                        checked={isPriceVisible}
                        onChange={(event) => setPriceVisibility(event.target.checked)}
                        name="display"
                        color="primary"
                        value="Price"
                      />
                    }
                    label={t('campaigns.price')}
                  />
                </div>

                <div className={clsx(classes.dInlineBlock, classes.pb10)}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={isButtonVisible}
                        checked={isButtonVisible}
                        onChange={(event) => setButtonVisibility(event.target.checked)}
                        name="display"
                        color="primary"
                        value="Button"
                      />
                    }
                    label={t('campaigns.button')}
                  />
                </div>
              </div>

              <div className={clsx(classes.mb5)}>
                {t('campaigns.buttonText')}
              </div>
              <Input
                className={clsx(classes.dBlock, classes.borderAround, classes.pl10, classes.pr10)}
                placeholder={t('campaigns.buyNow')}
                defaultValue={buttonText}
                onChange={(event: any) => setButtonText(event.target.value)}
              ></Input>
            </Grid>
            <Grid item md={7}>
              <h4 className={clsx(classes.bold, classes.pt5, classes.noMargin, classes.pb10)}>{t('campaigns.productStructure')}:</h4>
              <Grid container spacing={5}>
                <Grid item md={4}>
                  <FormControl
                    variant="standard"
                    className={clsx(classes.dBlock, classes.selectInputFormControl)}
                  >
                    <Select
                      variant="standard"
                      id='category'
                      value={structure}
                      onChange={(event: any) => setStructure(event.target.value)}
                      IconComponent={() => <IoIosArrowDown size={20} className={classes.dropdownIconComponent} />}
                      style={{ width: '100%' }}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 300,
                            direction: isRTL ? 'rtl' : 'ltr'
                          },
                        },
                      }}
                    >
                      <MenuItem key={Structure.Horizontal} value={Structure.Horizontal}>{t('campaigns.horizontal')}</MenuItem>
                      <MenuItem key={Structure.Vertical} value={Structure.Vertical}>{t('campaigns.vertical')}</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item md={4}>
                  <FormControl
                    variant="standard"
                    className={clsx(classes.dBlock, classes.selectInputFormControl)}
                  >
                    <Select
                      variant="standard"
                      id='direction'
                      value={direction}
                      onChange={(event: any) => setDirection(event.target.value)}
                      IconComponent={() => <IoIosArrowDown size={20} className={classes.dropdownIconComponent} />}
                      style={{ width: '100%' }}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 300,
                            direction: isRTL ? 'rtl' : 'ltr'
                          },
                        },
                      }}
                    >
                      <MenuItem key={Direction.LeftToRight} value={Direction.LeftToRight}>{t('campaigns.leftToRight')}</MenuItem>
                      {
                        structure === Structure.Vertical && <MenuItem key={Direction.Center} value={Direction.Center}>{t('campaigns.center')}</MenuItem>
                      }
                      <MenuItem key={Direction.RightToLeft} value={Direction.RightToLeft}>{t('campaigns.rightToLeft')}</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              {
                isSingleOrMultiple === Items.Multiple && (
                  <>
                    <h4 className={clsx(classes.bold, classes.pt5, classes.mb10)}>{t('campaigns.productOrder')}:</h4>
                    <Grid container spacing={5}>
                      <Grid item md={4}>
                        <FormControl
                          variant="standard"
                          className={clsx(classes.dBlock, classes.selectInputFormControl)}
                        >
                          <Select
                            variant="standard"
                            id='productOrder'
                            value={productOrder}
                            onChange={(event: any) => setProductOrder(event.target.value)}
                            IconComponent={() => <IoIosArrowDown size={20} className={classes.dropdownIconComponent} />}
                            style={{ width: '100%' }}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 300,
                                  direction: isRTL ? 'rtl' : 'ltr'
                                },
                              },
                            }}
                          >
                            <MenuItem key={Structure.Horizontal} value={Structure.Horizontal}>{t('campaigns.horizontal')}</MenuItem>
                            {
                              structure !== Structure.Horizontal && <MenuItem key={Structure.Vertical} value={Structure.Vertical}>{t('campaigns.vertical')}</MenuItem>
                            }
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </>
                )
              }

              <h4 className={clsx(classes.bold, classes.pt5, classes.mb10)}>{t('campaigns.preview')}:</h4>
              <div className='preview' style={{ display: productOrder === Structure.Horizontal ? 'flex' : 'block', height: previewContainerHeight, minHeight: previewContainerHeight, maxHeight: previewContainerHeight, overflowY: 'auto', overflowX: 'auto' }}>
                {
                  [
                    times(uptoProducts, (i) => {
                      return (
                        <Preview
                          classes={classes}
                          width={productOrder === Structure.Horizontal ? 100 / uptoProducts : 100}
                          key={i}
                          isImageVisible={isImageVisible}
                          isNameVisible={isNameVisible}
                          isDescriptionVisible={isDescriptionVisible}
                          isPriceVisible={isPriceVisible}
                          isButtonVisible={isButtonVisible}
                          imageURL={isStaticOrDynamic === AddProductCatalogType.Dynamic ? NO_IMAGE_URL : get(staticProduct, [i + 1, 'ImageURLs'], NO_IMAGE_URL)}
                          name={isStaticOrDynamic === AddProductCatalogType.Dynamic ? ProductDetails.Name : get(staticProduct, [i + 1, 'Name'], '')}
                          description={isStaticOrDynamic === AddProductCatalogType.Dynamic ? ProductDetails.Description : get(staticProduct, [i + 1, 'Description'], '')}
                          price={isStaticOrDynamic === AddProductCatalogType.Dynamic ? ProductDetails.Price : `${get(staticProduct, [i + 1, 'MaxPrice'], '')}`}
                          buttonText={buttonText}
                          structure={structure}
                          direction={direction}
                          eventType={isStaticOrDynamic === AddProductCatalogType.Dynamic && isFilterByEventType ? getEventName(eventType) : ''}
                          category={
                            isStaticOrDynamic === AddProductCatalogType.Dynamic ? (isFilterIsByProductCategory ? productCategories.find((cat: any) => cat.CategoryId == category)?.CategoryName || t('campaigns.allCategories') : '') : ''}
                        />
                      )
                    }
                    )]
                }
              </div>
            </Grid>
          </Grid>
        </Box>
        {renderToast()}
      </div>
    </BaseDialog>
  )
}

export default ProductCatalog
